module.exports = __webpack_public_path__ + "static/media/FutureSolutions.ce409cd7.jpeg";